import * as Styled from './styled'
import { memo, useContext, useState } from 'react'
import { TtsItemContext } from 'containers/SubSidebar/TtsContent/List/Item/contextApi'
import { Text, Icon, AdvancedTooltip } from 'common-components'
import TripleStarsIcon from 'assets/svgr-icons/TripleStars.svg'
import SpeakerIcon from 'assets/svgr-icons/Speaker.svg'
import { useGetTtsItemSpeakerProps } from 'containers/SubSidebar/TtsContent/hooks'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { useSelector } from 'react-redux'
import { userSelectors } from 'store/features/user/selectors'
import CrownIcon from 'assets/svgr-icons/Crown.svg'

const TtsItemSpeakerToggler: React.FC = () => {
  const { toggleSpeakerFlyout, scrollableParentRef, id } =
    useContext(TtsItemContext)
  const [wrapperRef, setWrapperRef] = useState<HTMLDivElement | null>(null)

  const speakerData = useGetTtsItemSpeakerProps(id)
  const { displayName, hasEmotion, isPremium } = speakerData
  const isFreeUser = useSelector(userSelectors.isFreeUser)
  const isPremiumBadgeVisible = isPremium && isFreeUser

  return (
    <Styled.ToggleTTSSpeakerWrapper
      ref={setWrapperRef}
      onClick={toggleSpeakerFlyout}
    >
      <Styled.TtsSpeakerIcon
        icon={<SpeakerIcon />}
        customSize={12}
        color="secondarySemiDark"
      />
      <Text type="h4" color="secondarySemiDark" lineHeight="12px">
        {displayName}
      </Text>
      {isPremiumBadgeVisible ? (
        <Icon icon={<CrownIcon />} size="small" color="secondarySemiDark" />
      ) : (
        hasEmotion && (
          <Icon
            icon={<TripleStarsIcon />}
            size="small"
            color="secondarySemiDark"
          />
        )
      )}
      <AdvancedTooltip
        tooltipText={translate(T.CHANGE_SPEAKER)}
        tooltipPosition="top"
        btnRef={{ current: wrapperRef }}
        scrollableParentRef={scrollableParentRef}
      />
    </Styled.ToggleTTSSpeakerWrapper>
  )
}

export default memo(TtsItemSpeakerToggler)
